let deferredPromptEvent = null;

const EVT_CHANGED = "pwa:deferredprompt-changed";

export function isAppInstalled() {
  try {
    if (window.matchMedia?.("(display-mode: standalone)")?.matches) return true;
    if (window.matchMedia?.("(display-mode: fullscreen)")?.matches) return true;
    if (window.matchMedia?.("(display-mode: minimal-ui)")?.matches) return true;
    // iOS Safari
    if (window.navigator?.standalone) return true;
  } catch {
    // ignore
  }
  return false;
}

export function setDeferredPromptEvent(e) {
  deferredPromptEvent = e || null;
  try {
    window.dispatchEvent(new CustomEvent(EVT_CHANGED, { detail: { available: !!deferredPromptEvent } }));
  } catch {
    // no-op
  }
}

export function clearDeferredPromptEvent() {
  setDeferredPromptEvent(null);
}

export function getDeferredPromptEvent() {
  return deferredPromptEvent;
}

export function onDeferredPromptChanged(handler) {
  window.addEventListener(EVT_CHANGED, handler);
  return () => window.removeEventListener(EVT_CHANGED, handler);
}

